/*
Sohel 05/22/2023 2698964415 Added Imports and Exports in Schedular
Sohel 05/24/2023 2698964415 Added Export Format Type in Schedular
Ravi 05/29/2023 2698964415 Added code dropdown in Export and Import
Akhila 06/23/2023 2698964415 import file path field label name change
Suresh Peddavoora 06/23/2023 2698964415 Fixed Alignments for textfields
Akhila 30/06/2023 2698964415 condtionaly label name change for folder path and file name
Akhila 07/03/2023 2698964415 bug fix start time and end time in export task type
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import {
  Checkbox,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Tooltip,
} from '@material-ui/core';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import {getClientCodeDropDownData} from '../../../../../../redux/reducers/TriggerGroup';
import AddFileName from '../../../../Reports/AddReport/StepperComponents/AddFileName';
import {useSelector, useDispatch} from 'react-redux';
import DialogBox from '../../../../../../components/DialogBox';
import {Clear, Search} from '@material-ui/icons';
// import {upperCaseCode} from '../../../../../../components/UpperCaseCode';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import {getOptions} from '../../../../../../util/GetDropDownOptions';
import {EXPORT_FORMAT_TYPE} from '../../../../../../constants/Lookup';
import {
  fetchAllDataManagerCode,
  getExportFormatType,
} from '../../../../../../redux/reducers/DataManager';
import ReportFolderPath from '../../../../Reports/AddReport/StepperComponents/ReportFolderPath';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
export default function ImportExportTaskForm(props) {
  const {
    values,
    setFieldValue,
    touched,
    errors,
    setIsCodeSearch,
    setDmTableData,
    handleBlur,
  } = props;
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const [openFileName, setOpenFileName] = useState(false);
  const {exportFormatTypeData, allDataManagerCode} = useSelector(
    ({dataManagerGroup}) => dataManagerGroup,
  );

  const codeRef = useRef();
  const [folderPath, setFolderPath] = useState(false);

  const handleFileNameClose = () => {
    setOpenFileName(false);
    setFolderPath(false);
  };
  const [nameData, setNameData] = useState();
  const [namePopover, setNamePopover] = useState(false);
  const type = values?.taskType?.value === 'Exports' ? 'Export' : 'Import';
  const getRecordCodesData = () => {
    if (allDataManagerCode && allDataManagerCode?.length > 0) {
      return allDataManagerCode?.filter((i) => String(i.dmCode)?.startsWith(nameData));
    } else {
      return [];
    }
  };
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
    dispatch(getExportFormatType());
  }, []);
  useEffect(() => {
    dispatch(fetchAllDataManagerCode(type));
  }, [type]);

  window.onclick = function() {
    setNamePopover(false);
  };
  return (
    <Grid container spacing={2} className="new-standard-textfields">
      <>
        <Grid item xs={4} sm={6} md={4} xl={4} className="form-group" autoComplete="off">
          <TextField
            margin="dense"
            className={`${classes.labelName}`}
            id="dmCode"
            variant="outlined"
            placeholder={`Enter ${
              values.taskType?.value === 'Exports' ? 'Export' : 'Import'
            } Manager Name`}
            label={`${values.taskType?.value === 'Exports' ? 'Export' : 'Import'} Manager Name`}
            value={values?.dmCode}
            inputRef={codeRef}
            name="dmCode"
            onChange={(e) => {
              // const value = upperCaseCode(codeRef);
              setFieldValue('dmCode', e?.target?.value);
              if (e.target.value) {
                setNamePopover(true);
                setNameData(e?.target?.value);
              } else if (e.target.value === '') {
                setNamePopover(false);
              }
            }}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={'Search'}>
                    <Search
                      className={` ${classes.iconSearch}`}
                      onClick={() => setIsCodeSearch(true)}
                      size="sm"
                    />
                  </Tooltip>
                  <Tooltip title={'Clear'}>
                    <Clear
                      className={` ${classes.iconSearch}`}
                      onClick={(e) => {
                        setNamePopover(false);
                        setFieldValue('dmCode', '');
                        setIsCodeSearch(false);
                        setDmTableData({});
                        setFieldValue('startTime', '');
                        setFieldValue('endTime', '');
                        setFieldValue('clientCode', []);
                        setFieldValue('exportFormat', []);
                        setFieldValue('reportpathDm', []);
                        setFieldValue('outputFileName', []);
                      }}
                    />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
            fullWidth
            touched={touched.dmCode}
            error={Boolean(touched.dmCode && errors.dmCode)}
          />
          <FormHelperText>{touched.dmCode && errors.dmCode && errors.dmCode} </FormHelperText>
          <div className="windowcode-popover Add-trigger-group-popover">
            {namePopover &&
              getRecordCodesData()?.map((data, i) => (
                <MenuItem fullWidth key={i}>
                  {data?.dmCode}
                </MenuItem>
              ))}
          </div>
        </Grid>
        {values.taskType?.value === 'Imports' && (
          <Grid item sm={6} md={4} xl={4} className={` form-group `}>
            <GuiAutoComplete
              classes={{
                option: classes.option,
              }}
              name="clientCode"
              id="clientCode"
              size="small"
              value={values.clientCode}
              options={clientCodeDropdownData || []}
              getOptionLabel={(option) => {
                return option?.clientNumber ? option?.clientName : '';
              }}
              onChange={(e, value) => {
                setFieldValue('clientCode', value);
              }}
              renderInput={(params) => (
                <div className="select-field">
                  <GuiTextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    error={Boolean(touched?.clientCode && errors?.clientCode)}
                    // required
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    label="Client Code"
                    placeholder="Select Client Code"
                  />
                </div>
              )}
            />
            <FormHelperText variant="outlined">
              {touched?.clientCode && errors?.clientCode ? errors.clientCode : ''}
            </FormHelperText>
          </Grid>
        )}
        {values.taskType?.value === 'Exports' && (
          <>
            {['Y'].includes(values?.clientIdPrompt) ? (
              <Grid
                item
                sm={6}
                md={4}
                xl={4}
                className={`form-group autocomplete-field ${
                  values?.clientCode?.length > 2 && `autocomplete-checkbox`
                }`}
              >
                <FormControl margin="dense" variant="outlined" fullWidth>
                  <GuiAutoComplete
                    name="clientCode"
                    id="clientCode"
                    size="small"
                    limitTags={1}
                    classes={{
                      option: classes.option,
                      listbox: classes.listBox,
                    }}
                    disableCloseOnSelect
                    getOptionSelected={(option, value) =>
                      option?.clientNumber === value?.clientNumber
                    }
                    value={values?.clientCode?.length > 0 ? values?.clientCode : []}
                    multiple
                    onChange={(e, value) => {
                      setFieldValue('clientCode', value);
                    }}
                    options={clientCodeDropdownData || []}
                    autoHighlight
                    renderOption={(option, {selected}) => {
                      return (
                        <React.Fragment>
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={
                                <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                              }
                              checked={selected}
                            />
                          </>
                          {option?.clientName ? option?.clientName : ''}
                        </React.Fragment>
                      );
                    }}
                    getOptionLabel={(option) => {
                      return option?.clientName ? option?.clientName : '';
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          variant="outlined"
                          className={` autocomplete-multiselect-label ${classes.labelName}`}
                          margin="dense"
                          label={'Client Code'}
                          placeholder={`Select Client Code`}
                          error={Boolean(touched?.clientCode && errors?.clientCode)}
                          // required
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      </div>
                    )}
                  />
                </FormControl>
                <FormHelperText variant="outlined">
                  {touched?.clientCode && errors?.clientCode ? errors.clientCode : ''}
                </FormHelperText>
              </Grid>
            ) : (
              ''
            )}
            <Grid item sm={6} md={4} xl={4} className={` form-group `}>
              <GuiAutoComplete
                classes={{
                  option: classes.option,
                }}
                id="exportFormat"
                size="small"
                autoHighlight
                value={values?.exportFormat}
                options={getOptions(EXPORT_FORMAT_TYPE, exportFormatTypeData)}
                getOptionLabel={(option) => {
                  return option?.value ? option?.value : '';
                }}
                onChange={(_, data) => {
                  setFieldValue('exportFormat', data);
                }}
                renderInput={(params) => (
                  <div className="select-field">
                    <GuiTextField
                      className={` ${classes.labelName}`}
                      {...params}
                      variant="outlined"
                      fullWidth
                      label="Export Format Type"
                      error={Boolean(touched.exportFormat && errors.exportFormat)}
                      name="exportFormat"
                      required
                      placeholder="Select Export Format Type"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'off',
                      }}
                    />
                  </div>
                )}
              />
              <FormHelperText style={{color: 'red', paddingTop: '5px'}} variant="outlined">
                {touched.exportFormat && errors.exportFormat && errors.exportFormat}
              </FormHelperText>
            </Grid>
            {['Y'].includes(values?.auditDatesPrompt) ? (
              <Grid item md={4} xl={4}>
                <Grid container spacing={4}>
                  <Grid item sm={12} className="form-group">
                    {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={` ${classes.labelName} `}
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      fullWidth
                      value={values.startTime}
                      disableFuture={true}
                      name="startTime"
                      inputVariant="outlined"
                      onBlur={handleBlur}
                      required
                      helperText=""
                      label="Start Date"
                      onChange={(val) => {
                        setFieldValue("startTime", val);
                      }}
                      autoOk
                      margin="dense"
                      touched={touched?.startTime}
                      error={Boolean(touched?.startTime && errors?.startTime)}
                    />
                  </MuiPickersUtilsProvider>
                  <FormHelperText variant="outlined">
                    {touched?.startTime && errors?.startTime ? errors.startTime : ""}
                  </FormHelperText>
                   */}
                    <TextField
                      margin="dense"
                      variant="outlined"
                      className={` ${classes.labelName}`}
                      placeholder="MM/DD/YYYY or Today or T"
                      onBlur={handleBlur}
                      label={'Start Date'}
                      touched={touched?.startTime}
                      name={'startTime'}
                      required
                      error={Boolean(touched?.startTime && errors?.startTime)}
                      value={values?.startTime}
                      onChange={(e) => {
                        if (e.target.value) {
                          setFieldValue('startTime', e.target.value.toUpperCase());
                        } else {
                          setFieldValue('startTime', '');
                        }
                      }}
                      fullWidth
                    />
                    {/* </FormControl> */}
                    <FormHelperText variant="outlined">
                      {touched?.startTime && errors?.startTime ? errors.startTime : ''}
                    </FormHelperText>
                    {/* </div> */}
                  </Grid>
                  <Grid item sm={12} className="form-group">
                    {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={` ${classes.labelName}`}
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      fullWidth
                      value={values.endTime}
                      disableFuture={true}
                      name="endTime"
                      required
                      inputVariant="outlined"
                      onBlur={handleBlur}
                      helperText=""
                      label="End Date"
                      onChange={(val) => {
                        setFieldValue("endTime", val);
                      }}
                      autoOk
                      margin="dense"
                      touched={touched?.endTime}
                      error={Boolean(touched?.endTime && errors?.endTime)}
                    />
                  </MuiPickersUtilsProvider> */}
                    <TextField
                      margin="dense"
                      variant="outlined"
                      className={` ${classes.labelName}`}
                      placeholder="MM/DD/YYYY or Today or T"
                      onBlur={handleBlur}
                      label={'End Date'}
                      touched={touched?.endTime}
                      name={'endTime'}
                      required
                      error={Boolean(touched?.endTime && errors?.endTime)}
                      value={values?.endTime}
                      onChange={(e) => {
                        if (e.target.value) {
                          setFieldValue('endTime', e.target.value.toUpperCase());
                        } else {
                          setFieldValue('endTime', '');
                        }
                      }}
                      fullWidth
                    />
                    <FormHelperText variant="outlined">
                      {touched?.endTime && errors?.endTime ? errors.endTime : ''}
                    </FormHelperText>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
          </>
        )}
        {/* {values.taskType?.value === "Imports" && ( */}
        <Grid item sm={6} md={4} xl={4} className={` form-group `}>
          <TextField
            className={` ${classes.labelName}`}
            margin="dense"
            variant="outlined"
            placeholder={`Enter ${values.taskType?.value} Folder Path`}
            label={`${values.taskType?.value} Folder Path`}
            multiline
            rows={2}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  style={{cursor: 'pointer'}}
                  onClick={() => setFolderPath(true)}
                  position="start"
                >
                  <AddBoxOutlinedIcon />
                </InputAdornment>
              ),
            }}
            // InputLabelProps={{
            //   shrink: true,
            // }}
            name={'reportpathDm'}
            value={values?.reportpathDm}
            onChange={(e) => {
              setFieldValue('reportpathDm', e.target.value);
            }}
            fullWidth
            touched={touched.reportpathDm}
            error={touched.reportpathDm && errors.reportpathDm}
          />
          <FormHelperText
            style={{color: 'red', position: 'relative', paddingLeft: '22px'}}
            variant="outlined"
          >
            {touched.reportpathDm && errors.reportpathDm && errors.reportpathDm}
          </FormHelperText>
        </Grid>
        <Grid item sm={6} md={4} xl={4} className={` form-group `}>
          <TextField
            margin="dense"
            variant="outlined"
            className={` ${classes.labelName}`}
            placeholder={`Enter ${values.taskType?.value} File Name`}
            label={`${values.taskType?.value} File Name`}
            required={values.taskType?.value === 'Import'}
            multiline
            rows={2}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  style={{cursor: 'pointer'}}
                  position="start"
                  onClick={() => setOpenFileName(true)}
                >
                  <AddBoxOutlinedIcon />
                </InputAdornment>
              ),
            }}
            name={'outputFileName'}
            value={values?.outputFileName}
            onChange={(e) => {
              setFieldValue('outputFileName', e.target.value);
            }}
            fullWidth
            touched={touched.outputFileName}
            error={touched.outputFileName && errors.outputFileName}
          />
          <FormHelperText
            style={{color: 'red', position: 'relative', paddingLeft: '22px'}}
            variant="outlined"
          >
            {touched.outputFileName && errors.outputFileName && errors.outputFileName}
          </FormHelperText>
        </Grid>
        {/* )} */}
        <DialogBox
          open={openFileName}
          dialogClose={handleFileNameClose}
          hideFooter={true}
          maxWidth={'xl'}
          title={`${values.taskType?.value} File Name`}
        >
          <AddFileName
            setFieldValues={setFieldValue}
            setOpen={setOpenFileName}
            addValues={values}
            handleClose={handleFileNameClose}
            DmModuleType={values.taskType?.value}
          />
        </DialogBox>
        <DialogBox
          open={folderPath}
          dialogClose={handleFileNameClose}
          hideFooter={true}
          maxWidth={'xl'}
          title={`${values.taskType?.value} Folder Path`}
        >
          <ReportFolderPath
            setFieldValues={setFieldValue}
            setOpen={setOpenFileName}
            addValues={values}
            handleClose={handleFileNameClose}
            folderPath={folderPath}
            isScheduler={true}
            DmModuleType={values.taskType?.value}
          />
        </DialogBox>
      </>
    </Grid>
  );
}
